var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#999999;}\n\t.st2{clip-path:url(#SVGID_00000112612223218597069260000013751373991631396009_);}\n\t.st3{clip-path:url(#SVGID_00000083805503123615602860000006937477360465922463_);}\n\t.st4{fill:none;stroke:#999999;stroke-width:2.2321;}\n\t.st5{clip-path:url(#SVGID_00000157272591340010181430000003290374471702969264_);}\n\t.st6{fill:#FF6CE2;}\n\t.st7{fill:#7B3566;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "volume_up_white_24dp",
    transform: "translate(-6265 7753.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    className: "st0",
    d: "M6265-7753.5h50v50h-50V-7753.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    className: "st1",
    d: "M6270.77-7734.93v12.86h8.55l10.69,10.71v-34.28l-10.69,10.71H6270.77z M6299.62-7728.5 c0-3.66-2.07-7-5.35-8.63v17.24C6297.55-7721.51,6299.62-7724.85,6299.62-7728.5z M6294.27-7747.29v4.42 c7.94,2.39,12.44,10.77,10.05,18.71c-1.45,4.82-5.22,8.59-10.05,10.05v4.41c10.38-2.38,16.87-12.72,14.49-23.1 C6307.11-7740.02,6301.48-7745.65,6294.27-7747.29L6294.27-7747.29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons01);
export default __webpack_public_path__ + "static/media/Icons-01.f759a712649449516900ad8e298d877e.svg";
export { ForwardRef as ReactComponent };